// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"91bfdff6","403":"51dc4b64","551":"76a84378","629":"c943924f","869":"e29a6847"}[chunkId] + ".chunk.js";
};